
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(app(_(translations_(de|en\-US|es\-419|fr|it|ko|pt\-BR|zh\-TW)_json|images_(add\-devices\-icon_svg\-app_images_coachmark\-artboard_svg\-app_images_labs\-chip_svg\-ap\-acb7a5|pageNotFound_png\-app_app_js))|)|env\-packages_envs_env_js)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
